import { useMediaQuery } from '@preownedfront/lib-reowds';

const useResponsive = () => {
  const WSXS = useMediaQuery("(max-width: 767px)");
  const WS = useMediaQuery("(min-width: 768px)");
  const WSM = useMediaQuery("(min-width: 1024px)");
  const WSL = useMediaQuery("(min-width: 1280px)");
  const WSLG = useMediaQuery("(min-width: 1440px)");
  const WSXL = useMediaQuery("(min-width: 1920px)");
  const WSFinePointer = useMediaQuery("(pointer: fine) and (hover: hover) and (max-width: 767px)");

  return {
    WSXS,
    WS,
    WSM,
    WSL,
    WSLG,
    WSXL,
    WSFinePointer,
  };
};

export default useResponsive;
